import _ from "lodash";
import DebugLogger from "../../../../utils/DebugLogger";
import DynamicServiceHelper from "./DynamicServiceHelper";
import { generateUUID } from "../../../../utils/Helper";

const TAG = "RNSpeechRecognize SS";

export default class SingSoundSpeechRecognitionService {
    TIMEOUT_SECONDS = 180;

    appKey = "";
    endpoint = "";
    userId = "";
    signature = "";
    useProxy = false;
    proxyAddress = "";

    //for now it is generate by java code, if we use this, we should generate token in the server side.
    token = null;
    expireTime = 0;
    timestamp = 0;

    streamSendingError = false;
    realTimeVoiceDataWriter = null;

    tmpReferenceText = null;
    tmpCallback = null;
    isRecording = false; // we will not throw exception/reject promise when recording for stream request

    constructor(configMap) {
        this.appKey = configMap.appKey;
        this.token = configMap.token;
        this.expireTime = configMap.expireTime;
        this.timestamp = configMap.timestamp;
        //TODO:: change it to the Live endpoint for singsound
        this.endpoint = "https://ginger-trial.api.cloud.ssapi.cn/";
        this.userId = configMap.userId;
        this.signature = configMap.signature;

        if (_.has(configMap, "useProxy")) {
            this.useProxy = configMap.useProxy;
        }
        if (_.has(configMap, "proxyAddress")) {
            this.proxyAddress = configMap.proxyAddress;
        }
    }

    Recognize(referenceText, wav, callback) {
        //start request.

        DebugLogger.log(TAG, "ajax call start");
        const connectId = generateUUID();
        const requestId = generateUUID();
        const requestUrl = this.GenerateUrl(this.appKey, this.endpoint, this.token, requestId, connectId);

        //initializeToken();
        const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 6, this.useProxy, this.proxyAddress);
        const jsonStr = this.GetParamJson(referenceText, requestId, connectId).toString();
        let formData = new FormData();
        formData.append("text", jsonStr);
        formData.append("audio", wav);

        fetch(finalUrl, {
            method: "POST",
            processData: false,
            contentType: false,
            headers: {
                "Request-Index": "0",
                "Content-type": "multipart/form-data",
                Accept: "application/json",
                //"Content-Length": audioContent.length,
            },
            body: formData,
        })
            .then(response => response.json())
            .then(responseData => {
                if (responseData.result) {
                    callback.onSuccess("", responseData.result);
                } else {
                    callback.onFailure("Request Failed", responseData.message);
                }
            })
            .catch(err => {
                DebugLogger.log("_postFileApi err", err);
                callback.onFailure("Error", err.message);
            });

        DebugLogger.log(TAG, "ajax call build end");
    }

    BeforeSendVoiceData(referenceText, callback) {
        throw new Error("recognize with record is not supported");
    }

    SendVoiceData(voiceData, offset, length) {
        //if error in stream request, we just do not send anymore
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            try {
                this.realTimeVoiceDataWriter.write(voiceData, offset, length);
            } catch (ex) {
                this.streamSendingError = true;
                DebugLogger.log(TAG, "SendVoiceData Error:");
                DebugLogger.log(TAG, ex.message);
            }
        }
    }

    AfterSendVoiceData(wav) {
        this.isRecording = false;
        DebugLogger.log(TAG, "AfterSendVoiceData");
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            DebugLogger.log(TAG, "AfterSendVoiceData Normal Case");
            this.realTimeVoiceDataWriter.stop();
            this.realTimeVoiceDataWriter = null;
        } else {
            DebugLogger.log(TAG, "AfterSendVoiceData Bad Case");
            this.Recognize(this.tmpReferenceText, wav, this.tmpCallback);
        }
    }

    IsErrorWhenSendingStream() {
        return this.streamSendingError;
    }

    NeedSendWavHeaderInNetworkStream() {
        return true;
    }

    getIsSpeechEvaluation() {
        return true;
    }

    destroy() {
        //nothing to do
    }

    GenerateUrl(appKey, endpoint, token, requestId, connect_id) {
        //https://api.cloud.ssapi.cn/en.word.score?appkey=t000&connect_id=41d52d4c51a211e8b8896be49fe3fb7a&request_id=4e632bf451a211e8b5740fbf49d552bd&warrant_id=5a7beb9c080882dd92de963e1f019
        let request = endpoint;

        request = _.endsWith("/", request) ? request : request + "/";
        request = request + "cn.sent.score";
        request = request + "?appkey=" + appKey;
        request = request + "&connect_id=" + connect_id;
        request = request + "&request_id=" + requestId;
        request = request + "&warrant_id=" + token;

        return request;
    }

    GetParamJson(referenceText, requestId, connect_id) {
        return {
            connect: {
                cmd: "connect",
                param: {
                    sdk: {
                        version: 1,
                        source: 1,
                        protocol: 1, //1: websocket，2: http
                        product: "YiDu",
                    },
                    app: {
                        warrantId: this.token,
                        applicationId: this.appKey,
                        timestamp: this.timestamp,
                        signature: this.signature,
                        userId: this.userId,
                        connect_id: connect_id,
                    },
                },
            },
            start: {
                cmd: "start",
                param: {
                    audio: {
                        sampleRate: 16000,
                        channel: 1,
                        sampleBytes: 2,
                        audioType: "wav",
                    },
                    app: {
                        warrantId: this.token,
                        applicationId: this.appKey,
                        timestamp: this.timestamp,
                        signature: this.signature,
                        userId: this.userId,
                        connect_id: connect_id,
                    },
                    request: {
                        precision: 1,
                        outputPhones: 2,
                        rank: 100,
                        refText: referenceText,
                        coreType: "cn.sent.score",
                        rateScale: 1.0,
                        request_id: requestId,
                    },
                },
            },
        };
    }
}
